import { useDispatch, useSelector } from 'react-redux';
import { setProfileViewing } from '../../Redux/store';
import ProfileRow from '../../components/ProfileRow';
import useProfileData from '../../hooks/useProfileData';

function ChatListItem({ chat, onChatSelect }) {
  const dispatch = useDispatch();
  const authUserId = useSelector((s) => s.user.authUserId);
  
  // Determine the other user's ID from user_ids array
  const otherUserId = chat.user_ids?.find(id => id !== authUserId);
  const { profile } = useProfileData(otherUserId);
  
  // Determine unread status for current user from read_by jsonb
  // New pattern: empty object = unread, has userId = read
  const isUnread = !(authUserId in (chat.read_by || {}));
  
  // Format time
  const time = chat.last_message_time 
    ? new Date(chat.last_message_time).toLocaleTimeString([], { hour: 'numeric', minute: '2-digit' })
    : '';

  if (!profile) return null;

  const handleClick = () => {
    // Call onChatSelect if provided (for desktop view)
    if (onChatSelect) {
      onChatSelect(chat);
    } else {
      // Default behavior for mobile view
      dispatch(setProfileViewing({ id: otherUserId, tab: 'chat' }));
    }
  };

  return (
    <li className="border-b border-border">
      <button 
        className="flex w-full items-center gap-3 px-4 py-3 text-left hover:bg-secondary"
        onClick={handleClick}
      >
        <ProfileRow 
          profile={profile} 
          size="md" 
          subtitle={chat.last_message || ''} 
          boldSubtitle={isUnread}
          boldName={isUnread}
        />
        <div className="ml-auto flex flex-col items-end gap-1">
          <span className="shrink-0 text-[11px] text-muted-foreground">{time}</span>
          {isUnread && <span className="h-2 w-2 shrink-0 rounded-full bg-primary" />}
        </div>
      </button>
    </li>
  );
}

export default ChatListItem;
